import { Component,
  Input,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Session } from '../../services/session';

import { setCookie, getCookie } from '@lib/cookies';
import { CookieKey } from '@lib/cookie-keys.const';
import { moment } from '@lib/moment';
import { mapValueToBoolean } from '@lib/utils';

import { FeatureUpgradeService } from './upgrade.service';
import {
  IUpgradeOptions,
  UPSELL_CONFIG,
  isValidUpsellFeatureKey,
  upsellEventId,
  IGeneralUpsellParams,
} from '@misc/upsell/upsell-config';
import { pushUpsellViewGTMEvent, UPSELL_COMPONENT_EVENT_NAME } from '@lib/gtm-events';

const ERROR_HIDE_TIME = 30000;

@Component({
  selector: 'general-upgrade',
  templateUrl: './general-upgrade.component.html',
  styleUrls: ['./general-upgrade.component.scss', '../../styles/upgrade.scss'],
})
export class GeneralUpgradeComponent {
  @ViewChild('trialActivatedModal', { static: true }) public trialActivatedModal;
  @ViewChild('thankYouModal', { static: true }) public thankYouModal;
  @Input() public featureKey: string;
  @Input() public getQuoteproductInterest: string;
  public options: IUpgradeOptions;
  public showUpgradeNow: boolean;
  public showError: boolean = false;
  public accountManager: any;
  public isAMAssigned: boolean;
  public showPlayBtn: boolean = true;
  public isAdmin: boolean;
  public isPaid: boolean;
  public upsellComponentId: string;
  private el: HTMLElement;
  private isFeatureTrialEnded: boolean;
  private isFleetManager: boolean;
  private isFleetAdmin: boolean;

  constructor(
    private session: Session,
    elRef: ElementRef,
    private featureUpgradeService: FeatureUpgradeService,
    private cdr: ChangeDetectorRef,
  ) {
    this.el = elRef.nativeElement;
    this.accountManager = session.getAccountManager();
    this.isAMAssigned = !!this.accountManager;
    this.isFeatureTrialEnded = session.isTrialEnded();
    this.isPaid = session.isCompanyPaidPlan();
    this.isFleetManager = session.isDispatcher();
    this.isFleetAdmin = session.isAdmin();
  }

  public get showTryForFreeBtn(): boolean {
    return this.options.isTrialBtn && this.isFleetAdmin && !this.session.isTrialRequested
     && !this.session.isGetAQuoteRequested && !this.session.isUpgradeRequested;
  }

  public get upgradeNow(): boolean {
    const showUpsellUpgradeBtn: boolean = mapValueToBoolean(getCookie(CookieKey.UPSELL_UPGRADE_BTN_SHOW));
    return ((this.options.isUpgradeBtn && ((showUpsellUpgradeBtn || this.session.isTrialRequested
      || this.isFeatureTrialEnded) || (this.isFleetManager && !this.isFleetAdmin))
      && !this.session.isUpgradeRequested));
  }

  public get getQuoteRequested(): boolean {
    return this.options.isGetQuoteBtn ? !this.session.isGetAQuoteRequested : false;
  }

  public get showQuoteRequestedBtn(): boolean {
    return this.options.isGetQuoteRequestedBtn ? this.session.isGetAQuoteRequested : false;
  }

  public get showUpgradeRequestedBtn(): boolean {
    return this.options.isUpgradeRequestedBtn ? this.session.isUpgradeRequested : false;
  }

  public ngOnInit(): void {
    this.options = UPSELL_CONFIG[this.featureKey];
    this.upsellComponentId = isValidUpsellFeatureKey(this.featureKey) ? upsellEventId(this.el, this.featureKey) : '';
  }

  public ngAfterViewInit(): void {
    // element is visible
    if (this.el.offsetParent !== null) {
      pushUpsellViewGTMEvent(
        UPSELL_COMPONENT_EVENT_NAME['general-upgrade'],
        this.upsellComponentId,
      );
    }
  }

  public upgradeToPro(campaignType: string, productInterest: string): void {
    const generalUpsellParams: IGeneralUpsellParams = {
      subscribeTo: campaignType,
      userEmail: this.session.getUserEmail(),
      firstName: this.session.getUserFirstName(),
      lastName: this.session.getUserLastName(),
      companyName: this.session.getCompany().name,
      productInterest,
    };

    this.featureUpgradeService.generalUpgrade(generalUpsellParams)
      .subscribe((): void => {
        this.thankYouModal.show();
        if (campaignType === 'upgrade_now') {
          setCookie(CookieKey.UPSELL_UPGRADE_BTN_SHOW, false, moment().add(24, 'hours'));
          this.session.refresh();
        }
      },
      () => {
        this.handleError();
      });
  }

  public tryForFree(): void {
    this.featureUpgradeService.getTrialFeature(this.session.getCompany().id, '')
    .subscribe(() => {
      this.trialActivatedModal.show();
      setCookie(CookieKey.UPGRADE_TOPBAR_STATUS, true);
    },
    () => {
      this.handleError();
    });
  }

  private handleError(): void {
    this.showError = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.showError = false;
      this.cdr.detectChanges();
    }, ERROR_HIDE_TIME);
  }
}
